import {SptSystemInformation} from '@spout/global-any/models';

export function getDesktopSerialNumber(
  desktopInformation: SptSystemInformation
) {
  return desktopInformation.system.serial;
  // return '';
}
